import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";
import { addNewDevice, removeDevice } from "./deviceSlice";


export const FetchDeviceList = createAsyncThunk(
  "FetchDeviceList",
  async ({ page, limit }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`device/list?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const CreateDevice = createAsyncThunk(
  "CreateDevice",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('', dispatch).post(`device/add`,);
      successMessage(response.data.responseMessage);
      dispatch(addNewDevice(response?.data));
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const DeleteDevice = createAsyncThunk(
  "DeleteDevice",
  async (id: string, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).delete(`device/${id}`);
      successMessage(response.data.message['details'])
      dispatch(removeDevice(id));
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);



